module.exports = __webpack_public_path__ + "static/media/sample_portrait.17cf12fe.png";